module.exports = __webpack_public_path__ + "static/media/trainingIcon.9a3702e2.svg";